import { Spin } from 'antd';
import React from 'react';
import { BarChart, Bar, ResponsiveContainer, XAxis, YAxis, Legend, Tooltip, CartesianGrid } from 'recharts';

const TransactionBarChart = ({ data = [], xField, yField, barColor = "#6294FA", barSize = 50 }) => {

      if (!data || data.length === 0) {
          return <div><Spin size='large'/></div>;
      }
      
      // Calculate dynamic barSize based on data length
      const dynamicBarSize = Math.max(20, 300 / data.length);
    return (
        <ResponsiveContainer width="100%" height={400}>
          <BarChart 
            data={data} 
            barSize={dynamicBarSize} 
            //margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey={xField} tick={{ fontSize: 12 }}/>
            <YAxis dataKey={yField}/>
            <Tooltip />
            <Legend />
            <Bar dataKey="transactions" fill={barColor} />
          </BarChart>
      </ResponsiveContainer>
    );
};

export default TransactionBarChart;